/**
 * Action validation utilities for chat actions
 */

import { AVAILABLE_ACTIONS, ACTION_TYPES } from '../../constants/chat';

export const validateActionContext = (actionType: string, tableId?: string): void => {
  const { DATASET_ACTIONS, TABLE_ACTIONS } = AVAILABLE_ACTIONS;
  const normalizedType = actionType.toLowerCase();

  if (!tableId && TABLE_ACTIONS.includes(normalizedType)) {
    throw new Error('This action requires an existing dataset');
  }

  if (tableId && DATASET_ACTIONS.includes(normalizedType)) {
    throw new Error('Dataset already exists');
  }
};

/**
 * Validate monitor action parameters
 */
export const validateMonitorActionParams = (
  actionType: string,
  parameters: Record<string, unknown> | undefined
): void => {
  const normalizedType = actionType.toLowerCase();

  // Actions that require monitor_id
  const requiresMonitorId = [
    ACTION_TYPES.UPDATE_MONITOR,
    ACTION_TYPES.DELETE_MONITOR,
    ACTION_TYPES.LIST_MONITOR_RUNS
  ];

  if (requiresMonitorId.includes(normalizedType) && !parameters?.monitor_id) {
    throw new Error('Monitor ID is required. Use "list monitors" first to find the monitor.');
  }

  // create_monitor_with_dataset requires specific parameters
  if (normalizedType === ACTION_TYPES.CREATE_MONITOR_WITH_DATASET) {
    if (!parameters?.event_type) {
      throw new Error('Event type is required for creating a monitor with dataset.');
    }
    if (!parameters?.entity_type) {
      throw new Error('Entity type is required for creating a monitor with dataset.');
    }
    if (!parameters?.criteria || !Array.isArray(parameters.criteria) || parameters.criteria.length === 0) {
      throw new Error('At least one criterion is required for creating a monitor with dataset.');
    }
    if (!parameters?.cron_expression) {
      throw new Error('Schedule (cron_expression) is required for creating a monitor with dataset.');
    }
  }
};

export const createActionMessage = (action: { type: string; description?: string }): string => {
  const actionMessages: Record<string, string> = {
    [ACTION_TYPES.CREATE_MONITOR]: 'Setting up a monitor on this dataset...',
    [ACTION_TYPES.CREATE_MONITOR_WITH_DATASET]: 'Creating a new monitor with dataset...',
    [ACTION_TYPES.LIST_MONITORS]: 'Fetching your monitors...',
    [ACTION_TYPES.UPDATE_MONITOR]: 'Updating monitor settings...',
    [ACTION_TYPES.DELETE_MONITOR]: 'Deleting monitor...',
    [ACTION_TYPES.LIST_MONITOR_RUNS]: 'Fetching monitor run history...'
  };

  const normalizedType = action.type.toLowerCase();
  return actionMessages[normalizedType] ||
    `Executing: ${action.description || action.type.replace(/_/g, ' ')}...`;
};